import { createInstance, I18nClient } from "@sailor/i18n-web";
import resources from "../locale/parker/resources";

class I18nManager {
  static instance: I18nClient = null;

  static getInstance() {
    if (this.instance === null) {
      this.instance = createInstance();
      this.instance.init({
        // lng: 'zh',
        fallbackLng: "zh",
        ns: ["parker"],
        defaultNS: "parker",
        resources,
        interpolation: {
          escapeValue: false, // react 不需要这个
        },
        react: {
          useSuspense: false,
        },
      });
      window.parkerI18nClient = this.instance;
    }
    return this.instance;
  }
}
export const i18nClient = I18nManager.getInstance();
